module.exports = __webpack_public_path__ + "static/media/enclosure-loop.90ca18d6.mp4";